// src/services/mollie/mollie.service.ts

import { MollieCreatePaymentRequest, MollieError, MollieMethod, MolliePayment } from 'doxecure-commons/lib/mollieTypes';
import { $defined } from 'foundation-ts/commons';
import { TSError } from 'foundation-ts/tserrors';
import { Resp } from 'foundation-ts/tsrequest';
import { Nullable } from 'foundation-ts/types';

import apiClient from './apiClient';

export class MollieService {

    constructor() {
    }

    // ------------------------------------------------------------------
    // Auth helpers
    // ------------------------------------------------------------------

    private handleError(error: any): never {
        if ($defined(error?.response?.data)) {
            const errorData = error.response.data as MollieError;
            TSError.throw(errorData.detail || errorData.title || 'Unknown Mollie error');
        }
        throw error;
    }

    // ------------------------------------------------------------------
    // Payments
    // ------------------------------------------------------------------

    /**
     * Create a new payment.
     * On success Mollie returns the payment object including a `_links.checkout.href`
     * URL to which the customer should be redirected.
     */
    // async createPayment(paymentRequest: MollieCreatePaymentRequest): Promise<Nullable<MolliePayment>> {
    //     try {
    //         const [resp, status] = await apiClient.createPayment(paymentRequest);
    //         if (status !== Resp.Created) {
    //             this.handleError(resp);
    //         }
    //         return resp;
    //     } catch (e) {
    //         throw e;
    //     }
    // }

    /**
     * Retrieve an existing payment by its Mollie payment ID (e.g. "tr_7UhSN1zuXS").
     */
    // async getPayment(paymentId: string): Promise<Nullable<MolliePayment>> {
    //     try {
    //         const [resp, status] = await apiClient.getPayment(paymentId);
    //         if (status !== Resp.OK) {
    //             this.handleError(resp);
    //         }
    //         return resp;
    //     } catch (e) {
    //         throw e;
    //     }
    // }

    // ------------------------------------------------------------------
    // Payment Methods
    // ------------------------------------------------------------------

    /**
     * List all payment methods enabled for this profile.
     * Pass `amount` to filter methods that support a specific currency/amount.
     */
    async getPaymentMethods(
        locale?: string,
        amount?: { value: string; currency: string }
    ): Promise<Nullable<MollieMethod[]>> {
        try {
            return await apiClient.getPaymentMethods(locale, amount);
            //const [resp, status] = await apiClient.getPaymentMethods(locale, amount);
            // if (status !== Resp.OK) {
            //     this.handleError(resp);
            // }
            // return resp;
        } catch (e) {
            throw e;
        }
    }

    // ------------------------------------------------------------------
    // Misc
    // ------------------------------------------------------------------

    clearAuth(): void {
    }
}